'use client';
import CartIcon from '@repo/ui/src/components/Icons/CartIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface CartIconButtonProps {
  count: number;
  onClick: () => void;
  badgeClassName?: string;
}

const CartIconButton = ({
  count,
  onClick,
  badgeClassName = 'bg-brand-400',
}: CartIconButtonProps) => (
  <button
    id="commerceMenu"
    aria-label={`Shopping cart, ${count} items`}
    onClick={onClick}
    className="p-3 relative tra-btn-bare rounded"
  >
    <CartIcon className="text-white w-6" />
    <span
      aria-hidden
      className={classNames(
        'tra-text-web-body-s-link !no-underline absolute top-1 right-1 text-white h-5 min-w-5 flex items-center justify-center px-1 rounded-full hover:text-white',
        badgeClassName,
      )}
    >
      {count}
    </span>
  </button>
);

export default CartIconButton;
